import { groups } from 'services/analytics/events/groups';
import { getAnalyticsClient } from 'services/apollo';
import { GroupsMetadataProps } from 'services/analytics/events/propertyTypes';
import { GroupMemberFragment } from 'services/apollo/fragments';
import gql from 'graphql-tag';

export const TrackingGroupPeopleFeedQuery = gql`
  query getGroupScreenPeopleFeedAnalytics($groupId: String!) {
    groupById(id: $groupId) {
      id
      name
      groupType
      activityFeed {
        pageInfo {
          total
        }
      }
      ...groupMemberResults
    }
  }
  ${GroupMemberFragment}
`;

export const trackingGroupPeopleFeed = (operation: any) => {
  const getDataForEvent = getAnalyticsClient().then((client) =>
    client.query({
      query: TrackingGroupPeopleFeedQuery,
      variables: { groupId: operation.variables.groupId },
      fetchPolicy: 'no-cache',
    })
  );
  getDataForEvent.then((response) => {
    const metadata: GroupsMetadataProps = {
      '[Group] Document count': response.data.groupById.activityFeed.pageInfo.total,
      '[Group] Member count': response.data.groupById.members.length,
      '[Group] Name': response.data.groupById.name,
      '[Group] Type': response.data.groupById.groupType,
    };
    groups.page.viewPeople(metadata);
  });
};
